import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';

export interface NaptaProject {
  project_id: string;
  project_name: string;
}

export interface NaptaProjectsApi {
  listProjects(): Promise<NaptaProject[]>;
}

export const naptaProjectsApiRef = createApiRef<NaptaProjectsApi>().with({
  id: 'plugin.scaffolder.napta-picker.api',
});

export class NaptaProjectsClient implements NaptaProjectsApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async listProjects(): Promise<NaptaProject[]> {
    // The napta-picker backend module mounts its route on the scaffolder plugin.
    const baseUrl = await this.discoveryApi.getBaseUrl('scaffolder');
    const response = await this.fetchApi.fetch(`${baseUrl}/napta-projects`);

    if (!response.ok) {
      const body = await response.text();
      throw new Error(
        `Failed to fetch Napta projects with status ${response.status}: ${body}`,
      );
    }

    return response.json() as Promise<NaptaProject[]>;
  }
}

export const naptaProjectsApi = ApiBlueprint.make({
  name: 'napta-projects',
  params: defineParams =>
    defineParams({
      api: naptaProjectsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new NaptaProjectsClient(discoveryApi, fetchApi),
    }),
});
